const publicGoal = (state = { isProcessing: false }, action) => {
  switch (action.type) {
    case 'GET_SUPPORTERS':
      return {
        ...state,
        isProcessing: true,
      };
    case 'GET_SUPPORTERS_SUCCESS':
      return {
        ...state,
        supporters: action.data,
        isProcessing: false,
      };
    case 'GET_SUPPORTERS_FAIL':
      return {
        error: action.error,
        isProcessing: false,
      };
    default:
      return state;
  }
};

export default publicGoal;
